import type { LiabilityFeatureConfig } from '../../../types/insurances/LiabilityFeatureConfig';

export const liability: LiabilityFeatureConfig = {
    overview: {
        details: {
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
    },
    history: {
        visible: false,
    },
};
